import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { addToast } from '../../../../actions/toasts'
import Button from '../../../shared/Button'
import { IconCopy, IconShareArrow } from '../../../shared/Icon'
import { PATH_HELPERS } from '../../../../constants/navigation'
import { selectCustomerId } from '../../../../store/selectors/customerProfile'
import { SearchListing } from '../../../../types/listings'
import styles from './ShareButton.module.scss'
import * as Sentry from '@sentry/browser'
import { TouchEvent, useState } from 'react'

interface ShareButtonProps {
  listing: SearchListing
  buttonClassName: string
}

export const ShareButton = ({ listing, buttonClassName }: ShareButtonProps) => {
  // fix for allowing users to scroll listings on mobile and retain ability
  // to tap the share button and not navigate to the details page
  const [isTouchMoving, setIsTouchMoving] = useState(false)
  const customerId = useSelector(selectCustomerId)
  const dispatch = useDispatch()

  if (navigator.share) {
    const handleShare = (e: TouchEvent<HTMLButtonElement> | MouseEvent) => {
      e.stopPropagation()
      e.preventDefault()

      navigator
        .share({
          title: 'Homebot Home Listing',
          url: PATH_HELPERS.listing.buildPath(customerId, listing.id),
        })
        .catch(e => Sentry.captureException(e))
    }

    return (
      <Button
        className={classNames(buttonClassName, styles.shareButton)}
        data-qa='shareButton'
        iconStart={IconShareArrow}
        aria-label='share button'
        onClick={e => handleShare(e)}
        onTouchMove={() => setIsTouchMoving(true)}
        onTouchEnd={e =>
          isTouchMoving ? setIsTouchMoving(false) : handleShare(e)
        }
      />
    )
  }

  if (navigator.clipboard) {
    const handleCopy = async (
      e: MouseEvent | TouchEvent<HTMLButtonElement>
    ) => {
      e.stopPropagation()
      e.preventDefault()

      if (navigator.clipboard) {
        await navigator.clipboard.writeText(
          `${window.location.origin}${PATH_HELPERS.listing.buildPath(
            customerId,
            listing.id
          )}`
        )
        dispatch(
          addToast({
            listingId: listing.id,
            message: 'Listing link copied!',
          })
        )
      }
    }

    return (
      <Button
        className={classNames(buttonClassName, styles.shareButton)}
        data-qa='copyButton'
        iconStart={IconCopy}
        aria-label='copy button'
        onClick={e => handleCopy(e)}
        onTouchMove={() => setIsTouchMoving(true)}
        onTouchEnd={e =>
          isTouchMoving ? setIsTouchMoving(false) : handleCopy(e)
        }
      />
    )
  }
  return null
}
